import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperations = ({ 
  selectedIncidents, 
  onSelectAll, 
  onDeselectAll, 
  isAllSelected,
  totalIncidents,
  onBulkAction 
}) => {
  const [selectedAction, setSelectedAction] = useState('');

  const bulkActionOptions = [
    { value: '', label: 'Select Action' },
    { value: 'assign', label: 'Assign to User' },
    { value: 'change-status', label: 'Change Status' },
    { value: 'escalate', label: 'Escalate' },
    { value: 'close', label: 'Close Incidents' },
    { value: 'export-selected', label: 'Export Selected' }
  ];

  const handleActionExecute = () => {
    if (selectedAction && selectedIncidents?.length > 0) {
      onBulkAction(selectedAction, selectedIncidents);
      setSelectedAction('');
    }
  };

  const handleSelectToggle = () => {
    if (isAllSelected) {
      onDeselectAll();
    } else {
      onSelectAll();
    }
  };

  if (selectedIncidents?.length === 0) {
    return null;
  }

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 mb-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={handleSelectToggle}
              className="w-4 h-4 text-primary bg-background border-border rounded focus:ring-primary focus:ring-2"
            />
            <span className="text-sm font-medium text-foreground">
              {selectedIncidents?.length} of {totalIncidents} selected
            </span>
          </div>

          {selectedIncidents?.length > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onDeselectAll}
              iconName="X"
              iconPosition="left"
            >
              Clear Selection
            </Button>
          )}
        </div>

        <div className="flex items-center space-x-2">
          <Select
            options={bulkActionOptions}
            value={selectedAction}
            onChange={setSelectedAction}
            placeholder="Select Action"
            className="w-40"
          />
          
          <Button
            variant="default"
            onClick={handleActionExecute}
            disabled={!selectedAction}
            iconName="Play"
            iconPosition="left"
          >
            Apply
          </Button>
        </div>
      </div>
      {/* Quick Action Buttons */}
      <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-accent/20">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('assign', selectedIncidents)}
          iconName="UserPlus"
          iconPosition="left"
        >
          Assign
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('escalate', selectedIncidents)}
          iconName="TrendingUp"
          iconPosition="left"
        >
          Escalate
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('close', selectedIncidents)}
          iconName="CheckCircle"
          iconPosition="left"
        >
          Close
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('export-selected', selectedIncidents)}
          iconName="Download"
          iconPosition="left"
        >
          Export
        </Button>
      </div>
    </div>
  );
};

export default BulkOperations;